import React, {useEffect, useState} from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from '@mui/material';

import {
    generateSuggestions,
    generateNudge,
} from '../Analyzer/AnalyzerFunctions';
import {
    TierProgress,
    SuggestionsBlock,
    NudgesBlock
} from '../Analyzer/AnalyzerDisplayFunctions';
import {testAnalyzer} from "../Analyzer/testAnalyzer";

function Analyzer({ Account, Events, onClose }) {
    const [suggestions, setSuggestions] = useState([]);
    const [analyzerData, setAnalyzerData] = useState(null);
    const [nudges, setNudges] = useState([]);

    useEffect(() => {
        const result = testAnalyzer(Account, Events, null);

        const tips = generateSuggestions({
            tier: result.tier,
            recentFeaturesUsed: result.recentFeaturesUsed,
            lowUsageFeatures: result.lowUsageFeatures,
            coverage: result.coverage // ← 👈 THIS
        });

        setSuggestions(tips);
        setAnalyzerData(result);

        const nudgeList = generateNudge(
            result.tier,
            { low: result.lowUsageFeatures, top: result.recentFeaturesUsed },
            result.coverage
        );
        setNudges(nudgeList);
    }, [Account, Events]);

    return (

        <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ background: '#fdf6f1', color: '#f09637' }}>
                🔍 Analyzer Insights
            </DialogTitle>
            <DialogContent dividers>
                {analyzerData && (
                    <>
                        <Typography gutterBottom>
                            <strong>Tier:</strong> {analyzerData.tier}
                        </Typography>
                        <Typography gutterBottom>
                            <strong>Qualified Events:</strong> {analyzerData.qualifiedEventCount} / {analyzerData.eventCount}
                        </Typography>
                        <Typography gutterBottom>
                            <strong>AI Concierge:</strong> {analyzerData.aiConcierge.name} ({analyzerData.aiConcierge.engagementLevel})
                        </Typography>
                        <TierProgress
                            currentTier={analyzerData.tier}
                            qualifiedEventCount={analyzerData.qualifiedEventCount}
                        />
                    </>
                )}

                <NudgesBlock nudges={nudges} />

                <SuggestionsBlock suggestions={suggestions} />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} variant="outlined" color="warning">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default Analyzer;
